import { Pipe, PipeTransform } from '@angular/core';
import { MassUploadValueMap } from '../interfaces/mass-upload-grid.interface';
import moment from 'moment';
import { SUBMISSION_DATE_FORMAT } from '../interfaces/mug-submission.interface';

@Pipe({
  name: 'massUploadValueMap',
  pure: true,
  standalone: false
})
export class MassUploadDisplayPipe implements PipeTransform {
  /**
   * Formats a form control value from the mass upload grid. It will auto format date controls.
   * If a valueMap is provided, it will attempt to map the raw value, like true or false, to a
   * value in the valueMap, like "Yes" or "No".
   * @param controlValue - The form control value
   * @param valueMap - Array of objects (optional)
   * 
   * @returns The displayValue of the matched object, or the formatted controlValue if not found
   */
  transform(controlValue: any, valueMap?: MassUploadValueMap[]): any {
    if (controlValue == null) {
      return '';
    }
    
    // Check if searchValue is a moment object
    if (moment.isMoment(controlValue)) {
      return controlValue.format(SUBMISSION_DATE_FORMAT);
    }

    // The hiosId field will be a full plan object so we want to return the plan name
    if (controlValue?.productName) {
      return controlValue.productName;
    }

    // Use the mapped value if a map was provided, otherwise use the raw value
    const found = valueMap?.find(item => item.jsonValue === controlValue);
    return found ? found.displayValue : controlValue;
  }
}
